import { Feature } from '../models';
import * as L from 'leaflet';
import * as icons from '../assets/icons';
/**
 * A collection of functions creating icons.
 * SHARED for many components, thus a factory in the services folder.
 */

/**
 * Sanitizes text by escaping HTML special characters
 * @param text The text to sanitize
 * @returns Sanitized text safe for HTML insertion
 */
function sanitizeText(text: string | undefined): string {
    if (!text) return '';
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}

// Leaflet icons
export const leafletIconFromFeature = (feature: Feature): L.Icon | L.DivIcon => {
    // For connectors, do not make an svg icon / use a more complex one with texts
    if (feature.properties && feature.properties.type === 'connector') {
        return L.divIcon({
            className: 'connector-label',
            html: feature.properties.url
                ? ''
                : `<div class="connector status-${feature.properties.status}" style="transform: rotate(${feature.properties.rotation || 0}deg)"><div class="name"><span>${sanitizeText(
                      feature.properties.name
                  )}</span></div><div class="text">${sanitizeText(feature.properties.text)}</div></div>`,
        });
    }
    const iconUrl =
        feature.properties && feature.properties.url
            ? feature.properties.url
            : feature.properties && feature.properties.type
              ? dataUrlFromIconName(feature.properties.type)
              : dataUrlFromIconName('unknown');
    return L.icon({
        iconUrl,
        iconSize: [20, 20],
        iconAnchor: [6, 6],
        popupAnchor: [-3, -30],
    });
};
export const leafletIconFromName = (name: string): L.Icon => {
    return L.icon({
        iconUrl: dataUrlFromIconName(name),
        iconSize: [18, 18],
        iconAnchor: [9, 9],
        popupAnchor: [-3, -76],
    });
};

// SVG as dataurl
export const svgFromIconName = (name: string): string => {
    return icons[name] ? icons[name] : icons.unknown;
};
// REGULAR SVG
export const dataUrlFromIconName = (name: string): string => {
    return 'data:image/svg+xml;utf8,' + (icons[name] ? icons[name] : icons.unknown);
};

// Tools for edit mode for image
export const toolForImage = (feature: Feature): L.DivIcon => {
    return L.divIcon({
        className: 'tools',
        html: `
        <nav class="nav" style="transform: rotate(${feature.properties.rotation || 0}deg)">
            <section class="bar horizontal">
                <button id="image" type="button" aria-label="Select background image tool">
                    ${svgFromIconName('settings')}
                </button>
            </section>
        </nav>`,
    });
};

// Name label for an image
export const nameLabelForImage = (feature: Feature): L.DivIcon => {
    return L.divIcon({
        className: 'name-label',
        html:
            feature.properties.name && feature.properties.name.length
                ? `<div class="name" style="transform: rotate(${feature.properties.rotation || 0}deg)">${sanitizeText(feature.properties.name)}</div>`
                : '<div class="name empty"></div>',
    });
};
